import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'
import {Container} from '../../modules/components'

export enum AccessRoutesEnum {
    DatatableAdmins = '/acessos/administradores',
    StoreAdmin = '/acessos/administradores/cadastrar',
    ShowAdmin = '/acessos/administradores/:id',
    DatatablePrivileges = '/acessos/perfis',
    StorePrivilege = '/acessos/perfis/cadastrar',
    UpdatePrivilege = '/acessos/perfis/editar/:id',
}

export default function AccessRouter() {
    const DatatableAdmins = lazy(() => import('../../pages/access/admins/DatatableAdmins'))
    const ShowAdmin = lazy(() => import('../../pages/access/admins/ShowAdmin'))
    const StoreAdmin = lazy(() => import('../../pages/access/admins/StoreAdmin'))

    const DatatablePrivileges = lazy(
        () => import('../../pages/access/privileges/DatatablePrivileges')
    )
    const StorePrivilege = lazy(() => import('../../pages/access/privileges/StorePrivilege'))
    const UpdatePrivilege = lazy(() => import('../../pages/access/privileges/UpdatePrivilege'))

    return (
        <Container loading={false}>
            <Switch>
                <Route path={AccessRoutesEnum.StoreAdmin} component={StoreAdmin} />
                <Route path={AccessRoutesEnum.ShowAdmin} component={ShowAdmin} />
                <Route path={AccessRoutesEnum.DatatableAdmins} component={DatatableAdmins} />

                <Route path={AccessRoutesEnum.UpdatePrivilege} component={UpdatePrivilege} />
                <Route path={AccessRoutesEnum.StorePrivilege} component={StorePrivilege} />
                <Route
                    path={AccessRoutesEnum.DatatablePrivileges}
                    component={DatatablePrivileges}
                />
            </Switch>
        </Container>
    )
}
